// DCC coverage. Priority markets carry full detail + client-record property
// counts supplied by the owner (profile site records, 2026-08-29).
// Headline figure used site-wide: 1000+ clients served · 26 markets.
export const PRIORITY_MARKETS = ["mumbai", "navi-mumbai", "thane", "pune", "bengaluru", "hyderabad", "goa", "delhi-ncr"];


// Extended footprint — owner-verified property counts per state (DCC client records).
export const EXTENDED_STATES = [
  { state: "Gujarat", count: 63 }, { state: "Kerala", count: 39 }, { state: "Madhya Pradesh", count: 24 },
  { state: "Andhra Pradesh", count: 23 }, { state: "Tamil Nadu", count: 19 }, { state: "Rajasthan", count: 17 },
  { state: "Uttar Pradesh", count: 11 }, { state: "West Bengal", count: 5 }, { state: "Punjab", count: 5 },
  { state: "Daman & Diu", count: 4 }, { state: "Uttarakhand", count: 2 }, { state: "Chhattisgarh", count: 2 },
  { state: "Odisha", count: 2 }, { state: "Bihar", count: 1 },
];

export const REGIONS = [
  {
    state: "Maharashtra",
    count: 300,
    cities: [
      { id: "mumbai", name: "Mumbai", lat: 19.08, lng: 72.88, priority: true, properties: 120, note: "Head office market — full five-service coverage with dedicated crews." },
      { id: "navi-mumbai", name: "Navi Mumbai", lat: 19.03, lng: 73.03, priority: true, properties: 27, note: "Corporate parks, hospitals and hospitality corridor coverage." },
      { id: "thane", name: "Thane", lat: 19.22, lng: 72.98, priority: true, properties: 13, note: "Commercial and industrial belt along the eastern corridor." },
      { id: "pune", name: "Pune", lat: 18.52, lng: 73.86, priority: true, properties: 37, note: "IT parks, hotels and industrial facilities across the metro." },
      { id: "nagpur", name: "Nagpur", lat: 21.15, lng: 79.09, priority: false, note: "Project-based mobilisation for commercial facilities." },
    ],
  },
  {
    state: "Karnataka",
    count: 135,
    cities: [
      { id: "bengaluru", name: "Bengaluru", lat: 12.97, lng: 77.59, priority: true, properties: 88, note: "IT campuses, hospitals and hospitality across the metro." },
      { id: "mysuru", name: "Mysuru", lat: 12.3, lng: 76.65, priority: false, note: "Project-based coverage for institutional and hotel facilities." },
    ],
  },
  {
    state: "Telangana",
    count: 85,
    cities: [
      { id: "hyderabad", name: "Hyderabad", lat: 17.38, lng: 78.49, priority: true, properties: 57, note: "IT parks, life-science facilities and hotels." },
    ],
  },
  {
    state: "Goa",
    count: 70,
    cities: [
      { id: "goa", name: "Goa", lat: 15.49, lng: 73.83, priority: true, properties: 47, note: "Resort and hospitality corridor — kitchen, laundry and duct programmes." },
    ],
  },
  {
    state: "Delhi NCR",
    count: 25,
    cities: [
      { id: "delhi-ncr", name: "Delhi NCR", lat: 28.61, lng: 77.21, priority: true, properties: 17, note: "National-capital region: offices, hotels, hospitals and retail." },
    ],
  },
  {
    state: "Gujarat",
    count: 95,
    cities: [
      { id: "ahmedabad", name: "Ahmedabad", lat: 23.02, lng: 72.57, priority: false, note: "Industrial and commercial coverage on project mobilisation." },
      { id: "surat", name: "Surat", lat: 21.17, lng: 72.83, priority: false, note: "Project-based coverage." },
    ],
  },
  {
    state: "Tamil Nadu",
    count: 30,
    cities: [
      { id: "chennai", name: "Chennai", lat: 13.08, lng: 80.27, priority: false, note: "Commercial and industrial facilities on programme schedules." },
    ],
  },
  {
    state: "Kerala",
    count: 60,
    cities: [
      { id: "kochi", name: "Kochi", lat: 9.93, lng: 76.27, priority: false, note: "Hospitality and healthcare coverage." },
    ],
  },
  {
    state: "West Bengal",
    count: 8,
    cities: [
      { id: "kolkata", name: "Kolkata", lat: 22.57, lng: 88.36, priority: false, note: "Eastern-region programmes for hotels and commercial buildings." },
    ],
  },
  {
    state: "Odisha",
    count: 3,
    cities: [
      { id: "bhubaneswar", name: "Bhubaneswar", lat: 20.3, lng: 85.82, priority: false, note: "Institutional and hospitality projects." },
    ],
  },
  {
    state: "Rajasthan",
    count: 25,
    cities: [
      { id: "jaipur", name: "Jaipur", lat: 26.91, lng: 75.79, priority: false, note: "Heritage-hotel and commercial coverage." },
    ],
  },
  {
    state: "Andhra Pradesh",
    count: 35,
    cities: [
      { id: "visakhapatnam", name: "Visakhapatnam", lat: 17.69, lng: 83.22, priority: false, note: "Industrial and port-city commercial facilities." },
    ],
  },
  {
    state: "Madhya Pradesh",
    count: 35,
    cities: [
      { id: "indore", name: "Indore", lat: 22.72, lng: 75.86, priority: false, note: "Project mobilisation for commercial facilities." },
    ],
  },
  {
    state: "Uttar Pradesh",
    count: 17,
    cities: [
      { id: "lucknow", name: "Lucknow", lat: 26.85, lng: 80.95, priority: false, note: "Commercial and institutional facilities on programme schedules." },
    ],
  },
  {
    state: "Punjab",
    count: 8,
    cities: [
      { id: "ludhiana", name: "Ludhiana", lat: 30.9, lng: 75.85, priority: false, note: "Industrial and hospitality coverage on project mobilisation." },
    ],
  },
  {
    state: "Daman & Diu",
    count: 6,
    cities: [
      { id: "daman", name: "Daman", lat: 20.4, lng: 72.83, priority: false, note: "Hospitality and industrial facilities in the coastal corridor." },
    ],
  },
  {
    state: "Uttarakhand",
    count: 3,
    cities: [
      { id: "dehradun", name: "Dehradun", lat: 30.32, lng: 78.03, priority: false, note: "Hotel and institutional projects by scheduled mobilisation." },
    ],
  },
  {
    state: "Chhattisgarh",
    count: 3,
    cities: [
      { id: "raipur", name: "Raipur", lat: 21.25, lng: 81.63, priority: false, note: "Commercial facilities on programme schedules." },
    ],
  },
  {
    state: "Bihar",
    count: 2,
    cities: [
      { id: "patna", name: "Patna", lat: 25.59, lng: 85.14, priority: false, note: "Institutional and hospitality projects." },
    ],
  },
  {
    state: "Andaman & Nicobar",
    count: 2,
    cities: [
      { id: "port-blair", name: "Sri Vijaya Puram (Port Blair)", lat: 11.62, lng: 92.73, priority: false, note: "Island hospitality projects by scheduled mobilisation." },
    ],
  },
];

export const ALL_MARKERS = REGIONS.flatMap((r) => r.cities.map((c) => ({ ...c, state: r.state })));
